export default __webpack_public_path__ + "static/media/bring-me-home-desktop.8c9027cd.jpg";